import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IBlog,
  IBlogResponseData,
  IBlogState,
  ICommentResponseData,
} from "../@types/blogs";
import { IApiResponse } from "../@types/api-response";

const initialState: IBlogState = {
  blogs: [],
  blog: null,
  comments: [],
  commentsLimit: 10,
  commentsTotal: 0,
  limit: 20,
  offset: 0,
  total: 0,
  blogsLoading: false,
  blogLoading: false,
  commentsLoading: false,
  commentSubmitting: false,
  blogsError: null,
  blogError: null,
  commentsError: null,
};

export const blog = createSlice({
  name: "blog",
  initialState,
  reducers: {
    setBlogs: (
      state,
      action: PayloadAction<IApiResponse<IBlogResponseData>>,
    ) => {
      state.blogs = action.payload.data.data;
      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
      state.blogsError = null;
    },
    setBlog: (state, action: PayloadAction<IBlog | null>) => {
      state.blog = action.payload;
      state.blogError = null;
    },
    setOffset: (state, action: PayloadAction<number>) => {
      state.offset = Math.max(0, action.payload);
    },
    setBlogsLoading: (state, action: PayloadAction<boolean>) => {
      state.blogsLoading = action.payload;
    },
    setBlogLoading: (state, action: PayloadAction<boolean>) => {
      state.blogLoading = action.payload;
    },
    setBlogsError: (state, action: PayloadAction<string | null>) => {
      state.blogsError = action.payload;
    },
    setBlogError: (state, action: PayloadAction<string | null>) => {
      state.blogError = action.payload;
    },
    setCommentsLoading: (state, action: PayloadAction<boolean>) => {
      state.commentsLoading = action.payload;
    },
    setCommentSubmitting: (state, action: PayloadAction<boolean>) => {
      state.commentSubmitting = action.payload;
    },
    setCommentsError: (state, action: PayloadAction<string | null>) => {
      state.commentsError = action.payload;
    },
    setComments: (
      state,
      action: PayloadAction<IApiResponse<ICommentResponseData>>,
    ) => {
      state.comments = action.payload.data.data;
      state.commentsLimit = action.payload.data.limit;
      state.commentsTotal = action.payload.data.total;
      state.commentsError = null;
    },
    clearComments: (state) => {
      state.comments = [];
      state.commentsTotal = 0;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setBlogs,
  setBlog,
  setOffset,
  setBlogsLoading,
  setBlogLoading,
  setBlogsError,
  setBlogError,
  setCommentsLoading,
  setCommentSubmitting,
  setCommentsError,
  setComments,
  clearComments,
} = blog.actions;

export default blog.reducer;
